export default __webpack_public_path__ + "static/media/doggo.8227bead.jpeg";